import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-search-field" }
const _hoisted_2 = ["aria-label"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_text_field = _resolveComponent("text-field")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_text_field, {
        ref: "textField",
        "display-name": $props.displayName,
        "label-class": $props.labelClass,
        "model-value": $props.modelValue,
        placeholder: $options.placeholderValue,
        "has-icon": "",
        "onUpdate:modelValue": $options.onInput,
        onKeydown: _cache[1] || (_cache[1] = $event => (_ctx.$emit('keydown', $event)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_base_icon, {
            name: "search",
            class: "gfu-search-field__icon"
          }),
          _withDirectives(_createElementVNode("button", {
            class: "_ha-right _tc--accent gfu-btn",
            "aria-label": _ctx.Resources.Common.AutocompleteClearButtonLabel,
            onClick: _cache[0] || (_cache[0] = (...args) => ($options.clearInput && $options.clearInput(...args))),
            "data-qa": "search-field:ClearInput"
          }, [
            _createVNode(_component_base_icon, { name: "times" })
          ], 8 /* PROPS */, _hoisted_2), [
            [_vShow, $props.modelValue]
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["display-name", "label-class", "model-value", "placeholder", "onUpdate:modelValue"])
    ])
  ]))
}